module.exports = "<!-- Footer -->\n<footer class=\"site-footer\">\n    <div class=\"site-footer-legal\">© 2017 <a href=\"http://icheck.vn\">iCheck</a></div>\n    <div class=\"site-footer-right\">\n        Sản phẩm của <a href=\"http://icheck.vn\">iCheck</a>\n    </div>\n</footer>\n<!-- Core  -->"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/footer/admin-footer.template.html
// module id = ../../../../../src/app/layout/footer/admin-footer.template.html
// module chunks = 3